import { TemplateDefaults } from "../../../library-templates/TemplateDefaults";
import { AttributeValue } from "../../dom-tools/AttributeValue";
import { ClassFlag } from "../../dom-tools/ClassFlag";
import { ElementAttribute } from "../../dom-tools/ElementAttribute";
import { ElementType } from "../../dom-tools/ElementType";
import { OnChange, OnClick } from "../../dom-tools/EventListeners";

export class ClickAction
{
  static readonly attribute = new ElementAttribute( "-click--action" );
  static readonly type = new ElementAttribute( "-click--type" );
  static readonly value = new ElementAttribute( "-click--value" );

  static readonly SET_CLASS     = new AttributeValue( ClickAction.type, "set-class" );
  static readonly SET_ATTRIBUTE = new AttributeValue( ClickAction.type, "set-attribute" );

  static applyOnDocument()
  {
    ClickAction.attribute.forEachInDoc( e => this.applyOnElement( e ) );
  }

  static applyOnElement( e:Element )
  {
    let selected = TemplateDefaults.getSelected( e );
    let target   = TemplateDefaults.getTarget( e ) || e; 

    if ( ElementType.select.is( selected ) )
    {
      let selectElement = selected as HTMLSelectElement;

      console.log( "IS SELECT ELEMENT" );
      OnChange.add( 
        selectElement, 
        ( ev )=>
        { 
          console.log( "ON SELECTED", ev );

          let selectedOption = selectElement.options[ selectElement.selectedIndex ];
          ClickAction.applyClickAction( selectedOption, target, e ); 
        }
      );

      let firstSelectedOption = selectElement.options[ selectElement.selectedIndex ];
      ClickAction.applyClickAction( firstSelectedOption, target, e ); 
    } 
    else
    {
      OnClick.add( 
        selected as HTMLElement, 
        ()=>
        { 
          ClickAction.applyClickAction( selected, target, e ); 
        } 
      );
    }
  }

  static applyClickAction( actionElement:Element, targetElement:Element, parentElement:Element )
  {
    console.log( "applyClickAction", actionElement, targetElement, parentElement );

    let value = ClickAction.value.from( actionElement );

    if ( ClickAction.SET_CLASS.in( actionElement ) )
    { 
      new ClassFlag( value ).set( targetElement );
    }

    else if ( ClickAction.SET_ATTRIBUTE.in( actionElement ) )
    { 
      let attributeValue = AttributeValue.parseAttributeValue( value );

      console.log( "SET ATTRIBUTE", attributeValue, targetElement );

      attributeValue.set( targetElement );
    }
  }
}